import React, { useEffect, useState } from "react";
import BlogCard from "./BlogCard";
import Button from "../button/Button";
import axiosInstance from "../../axiosinstance";
import { formatDate } from "../../utils/formatDate";
import "./Blogs.css";
import { useAutoHorizontalScroll } from "../../hooks/useAutoHorizontalScroll";
import { motion } from "framer-motion";
import { staggerContainer, fadeIn } from "../../utils/motion";

const Blogs = () => {
  const [blogs, setBlogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const scrollRef = useAutoHorizontalScroll({
    speed: 0.5,
    pauseOnHover: true,
  });

  useEffect(() => {
    async function fetchBlogs() {
      setLoading(true);
      try {
        const res = await axiosInstance.get("/allArticles", { params: { limit: 4, page: 1 } });
        const sorted = (res.data || []).sort(
          (a: any, b: any) =>
            new Date(b.publishDate).getTime() -
            new Date(a.publishDate).getTime()
        );
        setBlogs(sorted);
      } catch (err) {
        setBlogs([]);
      }
      setLoading(false);
    }
    fetchBlogs();
  }, []);

  return (
    <motion.section
      className="blogs-section"
      variants={staggerContainer(0.2, 0.3)}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
    >
      <motion.h2
        className="blogs-header comp"
        variants={fadeIn("up", "spring", 0.1, 0.8)}
        style={{ color: "#fff" }}
      >
        Latest Articles/Blog
      </motion.h2>

      <motion.div
        className="blogs-scroll-container"
        ref={scrollRef}
        variants={fadeIn("up", "spring", 0.2, 0.8)}
      >
        {loading ? (
          <div style={{ textAlign: "center", padding: "2rem" }}>Loading...</div>
        ) : blogs.length > 0 ? (
          blogs.slice(0, 4).map((blog, idx) => (
            <BlogCard
              key={blog._id || idx}
              image={
                blog.coverImage?.url || "/images/placeholder.svg"
              }
              title={blog.title}
              link={`/blog/single/${blog._id || blog.slug}`}
              date={formatDate(blog.publishDate)}
            />
          ))
        ) : (
          <div style={{ textAlign: "center", padding: "2rem" }}>
            No articles found.
          </div>
        )}
      </motion.div>

      <motion.div variants={fadeIn("up", "spring", 0.3, 0.8)}>
        <Button
          text="View More Inspiring Articles"
          onClick={() => (window.location.href = "/blog")}
        />
      </motion.div>

      <motion.div
        className="blogs-notify-text"
        variants={fadeIn("up", "spring", 0.4, 0.8)}
      >
        Get notified every time we post amazing contents
      </motion.div>
      <motion.div variants={fadeIn("up", "spring", 0.5, 0.8)}>
        <button
          type="button"
          className="blogs-notify-link"
          onClick={() => (window.location.href = "/blog#subscribe")}
        >
          Click here to join our mailing list
        </button>
      </motion.div>
    </motion.section>
  );
};

export default Blogs;
